import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d7twym21ud: FaireBrandEntity = {
  token: "b_d7twym21ud",
  type: "brand",
  name: "Casa Clara",
  avatarUrl: "https://cdn.faire.com/fastly/ebe7f8618bce664e39e6bed7d3405e7eb2c56381e09a31df914fac5ed3c33290.png",
  bannerUrl: "https://cdn.faire.com/fastly/9d2e130c34c1f180c6c2095738636e58a316ed0e2a4f3358002db2787fb0cf1b.png",
  logoUrl: "https://cdn.faire.com/fastly/ebe7f8618bce664e39e6bed7d3405e7eb2c56381e09a31df914fac5ed3c33290.png",
  heroImageUrl: "https://cdn.faire.com/fastly/9d2e130c34c1f180c6c2095738636e58a316ed0e2a4f3358002db2787fb0cf1b.png",
  location: "Oceanside, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description: "Casa Clara was founded in 2017 and is owned and operated by two friends who have worked together for years in the fashion industry. Casa Clara's vision is to create a brand filled with iconic gold staples and specialty handmade pieces from around the world. ",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:03.659Z",
    importedBy: "entity-db-cli"
  }
};
